import React from 'react';

const ScanIcon = ({ color = '#333333', style = {} }) => {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <mask
        id="mask0_1533_9695"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="52"
        height="52"
      >
        <rect width="52" height="52" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1533_9695)">
        <path
          d="M4.33398 14.1916V4.33331H14.1923V7.94439H7.94506V14.1916H4.33398ZM4.33398 47.6667V37.8084H7.94506V44.0556H14.1923V47.6667H4.33398ZM37.809 47.6667V44.0556H44.0562V37.8084H47.6673V47.6667H37.809ZM44.0562 14.1916V7.94439H37.809V4.33331H47.6673V14.1916H44.0562ZM38.2062 38.2416H41.5646V41.6H38.2062V38.2416ZM38.2062 31.525H41.5646V34.8833H38.2062V31.525ZM34.8479 34.8833H38.2062V38.2416H34.8479V34.8833ZM31.4895 38.2416H34.8479V41.6H31.4895V38.2416ZM28.1312 34.8833H31.4895V38.2416H28.1312V34.8833ZM34.8479 28.1667H38.2062V31.525H34.8479V28.1667ZM31.4895 31.525H34.8479V34.8833H31.4895V31.525ZM28.1312 28.1667H31.4895V31.525H28.1312V28.1667ZM41.5646 10.4V23.8333H28.1312V10.4H41.5646ZM23.834 28.1667V41.6H10.4007V28.1667H23.834ZM23.834 10.4V23.8333H10.4007V10.4H23.834ZM20.9451 38.7111V31.0555H13.2895V38.7111H20.9451ZM20.9451 20.9444V13.2889H13.2895V20.9444H20.9451ZM38.6757 20.9444V13.2889H31.0201V20.9444H38.6757Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ScanIcon;
